import { h } from "@stencil/core";
import { createContext } from '../../utils/createContext';
const { Consumer } = createContext({ defaultValue: 'foo' });
export class MyComponentGrandchild {
    render() {
        return (h(Consumer, null, ({ defaultValue }) => (h("div", null,
            "3. ",
            defaultValue,
            " (grandchild)"))));
    }
    static get is() { return "my-component-grandchild"; }
}
